import sign from './sign'

const training = {
  path: 'training',
  component: resolve => require(['../../../../pages/domain/sbs/training'], resolve),
  children: [
    sign
  ]
}

export default training
